import React from 'react';
import moment from 'moment';
import {
  Icon
} from '@material-ui/core';
import { DateRange } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardFooter from 'components/Card/CardFooter.js';

import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);

const DashboardCards = (props) => {

  const classes = useStyles();
    
  const dailyCardStats = (salesOrProfit) => {

    const todaysDate = moment();
    var totalDailyBooking = 0;
    var totalDailyProfit = 0;

    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      const currSalesOrder = props.salesOrders[i];
      if(todaysDate.isSame(currSalesOrder.startDate, 'day')) {
        totalDailyBooking += currSalesOrder.total;
      }
      for ( let j = 0; j < currSalesOrder.payments.length; j++ ) {
        if(todaysDate.isSame(currSalesOrder.payments[j].createdAt, 'day')) {
          totalDailyProfit += currSalesOrder.payments[j].amount;
        }
      }
    }

    for ( let i = 0; i < props.expenses.length; i++ ) {
      if(todaysDate.isSame(props.expenses[i].createdAt, 'day')) {
        totalDailyProfit -= props.expenses[i].total;
      }
    }

    if (salesOrProfit) return totalDailyBooking;
    else return totalDailyProfit;
  };

  const monthlyCardStats = (salesOrProfit) => {

    const todaysDate = moment();
    var totalMonthlyBooking = 0;
    var totalMonthlyProfit = 0;
    
    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      const currSalesOrder = props.salesOrders[i];
      if(todaysDate.isSame(currSalesOrder.startDate, 'month')) {
        totalMonthlyBooking += currSalesOrder.total;
      }
      for ( let j = 0; j < currSalesOrder.payments.length; j++ ) {
        if(todaysDate.isSame(currSalesOrder.payments[j].createdAt, 'month')) {
          totalMonthlyProfit += currSalesOrder.payments[j].amount;
        }
      }
    }

    for ( let i = 0; i < props.expenses.length; i++ ) {
      if(todaysDate.isSame(props.expenses[i].createdAt, 'month')) {
        totalMonthlyProfit -= props.expenses[i].total;
      }
    }

    if (salesOrProfit) return totalMonthlyBooking;
    else return totalMonthlyProfit;
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={3}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <Icon>content_copy</Icon>
            </CardIcon>
            <p className={classes.cardCategory}>Today's Booking</p>
            <h3 className={classes.cardTitle}>
              {dailyCardStats(true)} <small>AED</small> 
            </h3>
          </CardHeader>
          <CardFooter stats>
            
            <div className={classes.stats}>
            <DateRange />
            Current Date - {moment().format("DD/MM/YYYY")}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={3}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <Icon>content_copy</Icon>
            </CardIcon>
            <p className={classes.cardCategory}>Today's Profit</p>
            <h3 className={classes.cardTitle}>
              {dailyCardStats(false)} <small>AED</small> 
            </h3>
          </CardHeader>
          <CardFooter stats>
            
            <div className={classes.stats}>
            <DateRange />
            Current Date - {moment().format("DD/MM/YYYY")}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={3}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <Icon>content_copy</Icon>
            </CardIcon>
            <p className={classes.cardCategory}>Total Monthly Booking</p>
            <h3 className={classes.cardTitle}>
              {monthlyCardStats(true)} <small>AED</small> 
            </h3>
          </CardHeader>
          <CardFooter stats>
            
            <div className={classes.stats}>
            <DateRange />
            Current Month - {moment().format("MMMM")}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={3}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <Icon>content_copy</Icon>
            </CardIcon>
            <p className={classes.cardCategory}>Total Monthly Profit</p>
            <h3 className={classes.cardTitle}>
              {monthlyCardStats(false)} <small>AED</small> 
            </h3>
          </CardHeader>
          <CardFooter stats>
            
            <div className={classes.stats}>
            <DateRange />
            Current Month - {moment().format("MMMM")}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  )
};

export default DashboardCards;